import { Dispatch, SetStateAction, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import MagicUploadFilesTable from './MagicUploadFilesTable/MagicUploadFilesTable';
import MagicUploadCenter from './MagicUploadCenter/MagicUploadCenter';
import { MagicUploadFileData } from '../useFetchDataForMU';
import { MAGIC_UPLOAD } from '../Utils/MagicUploadConstants';

type DrawerContentProps = {
    tabState: string;
    toggleDrawer: () => void;
    setFileData: Dispatch<SetStateAction<MagicUploadFileData[]>>;
    fileData: MagicUploadFileData[];
};

const DrawerContent = (props: DrawerContentProps) => {
    const { tabState, fileData, setFileData } = props;
    const [searchParams] = useSearchParams();
    // Files handed off from an UploadJourney tab dropzone must not drain into the center while
    // the table's page-0 list fetch is in flight — that fetch REPLACES fileData wholesale, so an
    // early-drained row would vanish and never poll (RECUR-28067 D3 SF1/SF4). Starts true only
    // when the table is about to fetch (magicUpload=true), so it can never stick if the table's
    // effect early-returns.
    const [listFetchInFlight, setListFetchInFlight] = useState(searchParams.get(MAGIC_UPLOAD) === 'true');

    return (
        <div style={{ position: 'relative', height: '100%' }}>
            {tabState === 'all' && (
                <div>
                    <MagicUploadCenter
                        fileData={fileData}
                        setFileData={setFileData}
                        tabState={tabState}
                        orientation={'vertical'}
                        consumePendingUploads={!listFetchInFlight}
                    />
                </div>
            )}
            <MagicUploadFilesTable
                fileData={fileData}
                setFileData={setFileData}
                tabState={tabState}
                onListLoadingChange={setListFetchInFlight}
            />
        </div>
    );
};

export default DrawerContent;
